<template>
    <div class="d-calendar__group">
        <template v-if="access !== 'doctor'">
            <button v-if="!cell.booked" class="d-calendar__button r-button" type="button"
                    :class="{'d-calendar__button_selected': cell.chosen, 'd-calendar__button_noclicked': cell.appointment && (cell.start_at > dateNow.add(30, 'minute'))}"
                    :disabled="!cell.appointment || (cell.start_at < dateNow.add(30, 'minute')) || (cell.disabled && cell.chosen)"
                    @click="customerClickCell(cell)">
                <span class="screen-reader"
                      v-html="cell.start_at.format('dd, DD MMM HH:mm') + ' - ' + cell.end_at.format('HH:mm')">
                </span>
            </button>
            <calendar-mobile-popup v-if="!cell.booked && cell.showPopup"></calendar-mobile-popup>
            <div class="d-calendar__group" v-else-if="cell.booked">
                <div class="d-calendar__booked">
                    <span v-if="cell.start_at > dateNow">бронь</span>
                </div>
            </div>
        </template>
        <template v-else>
            <!--{{ cell.chosen }}-->
            <button type="button" :class="classes" :disabled="(!cell.booked && cell.start_at < dateNow.add(30, 'minute')) || cell.disabled" @click="vetClickCell(cell)">
                <span class="screen-reader" v-html="screenReaderText"></span>
                <span class="v-schedule__photo avatar" v-if="cell.appointment && cell.appointment.appointment_type && !cell.booked" style="color: white;">{{ cell.appointment.appointment_type.title }}</span>
            </button>
            <div class="d-calendar__booked" v-if="cell.booked && !cell.appointment.consultation.anonym" style="pointer-events: none;">
                <img v-if="cell.appointment.consultation.family" :src="cell.appointment.consultation.family.photo" class="v-schedule__photo avatar" :alt="cell.appointment.consultation.family.name">
                <img v-else :src="cell.appointment.consultation.patient.user.avatar" class="v-schedule__photo avatar" :alt="cell.appointment.consultation.patient.user.avatar">
            </div>
            <div class="d-calendar__booked" v-else-if="cell.booked && cell.appointment.consultation.anonym" style="pointer-events: none;">
                <img :src="anonymImg" class="v-schedule__photo avatar" alt="Аноним">
            </div>
            <calendar-pet-popup :cell="cell"></calendar-pet-popup>
        </template>
    </div>
</template>

<script>
	import {mapGetters, mapMutations, mapState} from 'vuex';

	import CalendarPetPopup from "./CalendarPetPopup.vue";
    import CalendarPopup from "./CalendarPopup.vue";
    import CalendarMobilePopup from "../mobile/CalendarMobilePopup";

    export default {
		name: 'CalendarCell',
		components: {
            CalendarMobilePopup,
			CalendarPetPopup,
            CalendarPopup
        },
		props: {
			cell: {
				type: Object,
				required: true
			}
		},
		data: () => ({
			user: window.laravel.user,
            anonymImg: window.laravel.anonymImg
		}),
		computed: {
			...mapState([
				'access',
				'dateNow',
                'showModal'
            ]),
			screenReaderText() {
				return 	this.cell.booked ? 'See more details about the family'
					: this.cell.start_at.format('dd, DD MMM HH:mm') + ' - ' + this.cell.end_at.format('HH:mm');
			},
			classes() {
				const classes = {
					'r-button': true,
				};

				if (this.cell.booked) {
					classes['calendar__showmore'] = true;
				} else {
					classes['d-calendar__button'] = true;
					classes['d-calendar__button_selected'] = this.cell.chosen;
                    classes['d-calendar__button_noclicked'] = this.cell.appointment;
				}

				return classes;
			}
		},
		methods: {
			...mapMutations([
				'chooseCell',
				'makeAppointment',
				'showPopupInfo'
			]),
            vetClickCell(cell) {
				if (this.cell.booked) {
					this.showPopupInfo(cell);
                } else {
					this.chooseCell(cell);
                }
            },
            customerClickCell(cell) {
			    this.makeAppointment(cell);
                this.showPopupInfo(cell);
            },
            disabled() {

            }
		},
	}
</script>


